import api from './api';

const buildHeaders = () => {
  const token = localStorage.getItem('access_token');
  const headers = {
    'Content-Type': 'application/json',
    client_id: process.env.REACT_APP_CLIENT_ID,
  };

  if (token) {
    headers.access_token = token;
  }

  return headers;
};

export async function getPainelMetas(siteCode) {
  const headers = buildHeaders();
  const storeIdSf = localStorage.getItem('storeId');
  const params = { siteCode };
  if (storeIdSf) {
    params.storeIdSf = storeIdSf;
  }

  return api.get('residential/store/v1/goals/painel-metas', {
    headers,
    params,
  });
}

export default {
  getPainelMetas,
};
